import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import './index.css';
import './css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FlashAlertProvider } from './contexts/flash-alert';
import { AuthProvider } from './contexts/AuthContext';
import { TabManagerProvider } from './contexts/tab-manager';
import { LoadingProvider } from './contexts/LoadingContext';


const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);
root.render(
  <React.StrictMode>
    <FlashAlertProvider>
      <LoadingProvider>
        <AuthProvider>
          <TabManagerProvider>
            <App />
          </TabManagerProvider>
        </AuthProvider>
      </LoadingProvider>
    </FlashAlertProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
